import { createActionType } from 'app/store/utils';

const type = createActionType('notification');

export const DISMISS_NOTIFICATION = type('DismissNotification');
export const SHOW_NOTIFICATION_SUCCESS = type('SHOW_NOTIFICATION_SUCCESS');
